import React from 'react';
import { Mic, Sparkles } from 'lucide-react';

interface GlowingCircleProps {
  volume: number; // 0 to 1
  isActive: boolean;
  colorClass?: string;
}

const GlowingCircle: React.FC<GlowingCircleProps> = ({ volume, isActive, colorClass = 'from-blue-600 to-purple-600' }) => {
  // Adjusted scale and glow for a more refined look
  const scale = 1 + volume * 0.4;
  const glowSize = volume * 30; // px

  return (
    <div className="relative flex items-center justify-center w-20 h-20">
      {/* Outer Glow / Ripple */}
      {isActive && (
        <div
          className={`absolute rounded-full opacity-30 transition-all duration-100 ease-out bg-gradient-to-r ${colorClass} blur-md`}
          style={{
            width: '100%',
            height: '100%',
            transform: `scale(${scale + 0.15})`,
          }}
        />
      )}

      {/* Inner Core */}
      <div
        className={`relative z-10 w-14 h-14 rounded-full shadow-xl transition-all duration-150 ease-out flex items-center justify-center border border-white/10 ${
          isActive 
            ? `bg-gradient-to-tr ${colorClass}` 
            : 'bg-gray-200 dark:bg-gray-800'
        }`}
        style={{
          transform: isActive ? `scale(${scale})` : 'scale(1)',
          boxShadow: isActive ? `0 0 ${glowSize}px rgba(59, 130, 246, 0.5)` : 'none',
        }}
      >
        {isActive ? (
           <div className="flex items-center gap-1 animate-pulse">
             {/* <Sparkles className="w-4 h-4 text-white" /> */}
             <span className="text-white font-bold text-xs tracking-wide">Meo</span>
           </div>
        ) : (
          <Mic className="w-6 h-6 text-gray-500 dark:text-gray-400" />
        )}
      </div>

      {/* Idle Ripple Animation */}
      {isActive && volume < 0.05 && (
        <div className="absolute w-14 h-14 rounded-full border border-blue-500/30 animate-ping opacity-30"></div>
      )}
    </div>
  );
};

export default GlowingCircle;